module.exports = __webpack_public_path__ + "img/Type_Fairy.f7785b82.png";